"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioButton = void 0;
var _defineProperty2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js"));
var _objectWithoutProperties2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _Input = require("../input/Input");
var _Tooltip = require("../../components/tooltip/Tooltip");
var _infoCircle = require("../../assets/icons/info-circle.svg");
var _radioButtonModule = _interopRequireDefault(require("./radioButton.module.scss"));
var _excluded = ["id", "className", "label", "tooltip", "checked", "disabled", "value", "transparent", "description", "children"];
var RadioButton = function RadioButton(_ref) {
  var _classnames;
  var id = _ref.id,
    className = _ref.className,
    label = _ref.label,
    tooltip = _ref.tooltip,
    checked = _ref.checked,
    disabled = _ref.disabled,
    value = _ref.value,
    transparent = _ref.transparent,
    description = _ref.description,
    children = _ref.children,
    allOtherProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: id,
    className: (0, _classnames2.default)(_radioButtonModule.default['radio-button'], className, (_classnames = {}, (0, _defineProperty2.default)(_classnames, _radioButtonModule.default['radio-button--disabled'], disabled), (0, _defineProperty2.default)(_classnames, _radioButtonModule.default['radio-button--checked'], checked), (0, _defineProperty2.default)(_classnames, _radioButtonModule.default['radio-button--transparent'], transparent), _classnames))
  }, /*#__PURE__*/_react.default.createElement(_Input.Input, Object.assign({}, allOtherProps, {
    id: id,
    value: value,
    disabled: disabled,
    className: _radioButtonModule.default['radio-button__input'],
    extensionProps: {
      type: 'radio',
      checked: checked,
      autoComplete: 'off'
    }
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: _radioButtonModule.default['radio-button__checkmark']
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _radioButtonModule.default['radio-button__input-container']
  }, label, tooltip && /*#__PURE__*/_react.default.createElement(_Tooltip.Tooltip, {
    size: "medium",
    className: _radioButtonModule.default.tooltip,
    title: tooltip
  }, /*#__PURE__*/_react.default.createElement(_infoCircle.ReactComponent, {
    className: _radioButtonModule.default['tooltip-icon']
  }))), description && /*#__PURE__*/_react.default.createElement("p", {
    className: _radioButtonModule.default['radio-button__description']
  }, description), children && /*#__PURE__*/_react.default.createElement("div", {
    className: _radioButtonModule.default['radio-button__children']
  }, children));
};
exports.RadioButton = RadioButton;